<template>
  <b-sidebar
    id="edit-order-movement-details"
    ref="modal"
    header-class="headerModalToggle"
    right
    shadow
    size="l"
    width="60%"
    :title="$t('OrderMovementDetails')"
    @hidden="onCancelToggle"
  >
    <template #title>
      <strong style="color: #101828;">{{ $t('OrderMovementDetails') }}: {{ getOrderMovementDetails?.orderMovementNumber }}</strong>
    </template>
    <template
      v-slot:header-close
    >
      <button
        style="color: #98A2B3;padding-left: 0px; padding-right: 0px;height: 60px;"
        class="fa fa-close"
        @click="onCancelToggle"
      />
    </template>
    <div style="padding:20px;">
      <LoadingWrapperSpinner
        request-id="loadOrderMovementDetails"
        class="display-elements"
      >
        <b-form-group
          :label="$t('deliverStoreName')"
        >
          <vue-select
            v-model="deliverStoreName"
            :options="filteredStoresDeliverer"
            label="deliverStoreName"
            :reduce="(e) => e.storeId"
            disabled
            :clearable="false"
            :placeholder="$t('SelectFiliale')"
            style="width: 100%; min-width: 100%; max-width: 100%;"
          />

        </b-form-group>

        <b-form-group
          :label="$t('receiverStoreName')"
        >
          <LoadingWrapperSpinner
            request-id="loadUpdateReceiverStoreIdByOrderMovement"
          >
            <vue-select
              v-model="receiverStoreName"
              :options="filteredStoresReceiver"
              label="receiverStoreName"
              :reduce="(e) => e.storeId"
              :clearable="false"
              :disabled="orderMovementState != 'PrepareInTransit'"
              :placeholder="$t('SelectFiliale')"
              style="width: 100%; min-width: 100%; max-width: 100%;"
              @input="updateReceiver"
            />
          </LoadingWrapperSpinner>

        </b-form-group>
        <b-form-group
          :label="$t('ResponsibleUser')"
        >
          <LoadingWrapperSpinner
            request-id="loadUpdateUserIdByOrderMovement"
          >
            <vue-select
              v-model="responsibleUser"
              :options="filteredResponsibleUsers"
              label="userFullName"
              :reduce="(e) => e.userId"
              :disabled="orderMovementState != 'PrepareInTransit'"
              :placeholder="$t('Select')"
              style="width: 100%; min-width: 100%; max-width: 100%;"
              @input="updateResponsibleUser"
            />
          </LoadingWrapperSpinner>

        </b-form-group>

        <b-form-group
          :label="$t('deliverDate')"
        >
          <LoadingWrapperSpinner
            request-id="loadUpdateDeliveryDateByOrderMovement"
          >
            <date-picker
              v-model="deliveryDate"
              type="date"
              :placeholder="$t('SelectD')"
              value-type="format"
              format="YYYY-MM-DD"
              :disabled="orderMovementState != 'PrepareInTransit'"
              :clearable="false"
              style="width:100%"
              @input="updateDeliveryDate"
            />
          </LoadingWrapperSpinner>
        </b-form-group>
        <b-form-group
          :label="$t('State')"
        >
          <LoadingWrapperSpinner>
            <vue-select
              :value="$t(orderMovementState)"
              :clearable="false"
              disabled
            />
          </LoadingWrapperSpinner>
        </b-form-group>
        <div
          class="dropdown-item-span"
          style="align-items:flex-end;"
        >
          <img
            style="cursor:pointer;width:30px;height:30px;"
            src="../../../assets/images/pdf-invoice-logo.svg"
            @click="downloadPDF(clickedOrderMovementId)"
          >
        </div>
      </LoadingWrapperSpinner>
      <div
        v-if="orderMovementState === 'InTransit'"
        style="margin-top:10px;display:flex;justify-content: flex-end;"
        class="table-elements"
      >
        <button
          v-b-modal.order-movements-locations
          class="primary"
        >
          {{ $t('Location') }}
        </button>
      </div>
      <div
        style="margin-top:10px;"
        class="table-elements"
      >
        <h4>
          {{ $t('Orders') }}
        </h4>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th
                v-if="orderMovementState === 'InTransit'"
                style="display: flex;gap: 5px"
              >
                <input
                  type="checkbox"
                  :checked="selectAllOrders"
                  @change="toggleSelectAllOrdersOrder"
                >
                {{ $t('Select') }}
              </th>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('OrderNumber') }}
              </th>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('State') }}
              </th>
              <th>
                {{ $t('Actions') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
            :is-loading="isRequestLoading('loadOrderMovementDetails')"
            :response-data="getOrderMovementDetails?.lineItemMovementPendingResponseDtos || []"
          >
            <tr
              v-for="(article, index) in getOrderMovementDetails?.lineItemMovementPendingResponseDtos"
              :key="index"
            >
              <td
                v-if="orderMovementState === 'InTransit'"
              >
                <input
                  type="checkbox"
                  :value="article.windowItemId"
                  :checked="isOrderItemChecked(article)"
                  @change="event => toggleOrderItem(event, index)"
                >
              </td>
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ article.orderNumber }}
              </td>
              <td>
                {{ article.articleNumber }}
              </td>
              <td>
                {{ $t(article.state) || $t('NotAccepted') }}
              </td>
              <td>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <b-icon-three-dots-vertical
                      class="h6"
                      style="color:black"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="orderMovementState === 'PrepareInTransit'"
                    v-b-modal.delete-line-item-in-movement-modal
                    @click="deleteLineItem(article)"
                  >
                    <span
                      style="display:flex;gap:5px"
                    >
                      <b-icon-trash />
                      <p>
                        {{ $t('Delete') }}
                      </p>
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="orderMovementState === 'InTransit'"
                  >
                    <span style="display:flex;gap:5px">
                      <b-icon-pencil />
                      <p>
                        {{ $t('Edit') }}
                      </p>
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <div
        style="margin-top:10px;"
        class="table-elements"
      >
        <h4>
          {{ $t('Articles') }}
        </h4>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th
                v-if="orderMovementState === 'InTransit'"
                style="display: flex;gap: 5px"
              >
                <input
                  type="checkbox"
                  :checked="selectAllProducts"
                  @change="toggleSelectAllProductsProducts"
                >
                {{ $t('Select') }}
              </th>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('Barcode') }}
              </th>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('Amount') }}
              </th>
              <th>
                {{ $t('State') }}
              </th>
              <th>
                {{ $t('Actions') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
            :is-loading="isRequestLoading('loadOrderMovementDetails')"
            :response-data="getOrderMovementDetails?.productInStockMovementPendingResponseDtos || []"
          >
            <tr
              v-for="(article, index) in getOrderMovementDetails?.productInStockMovementPendingResponseDtos"
              :key="index"
            >
              <td
                v-if="orderMovementState === 'InTransit'"
              >
                <input
                  type="checkbox"
                  :value="article.productInStockId"
                  :checked="isProductItemChecked(article)"
                  @change="event => toggleProductItem(event, index)"
                >
              </td>
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ article.barcode || $t('NoBarcode') }}
              </td>
              <td>
                {{ article.articleNumber }}
              </td>
              <td>
                {{ article.amount }}
              </td>
              <td>
                {{ $t(article.state) || $t('NotAccepted') }}
              </td>
              <td>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <b-icon-three-dots-vertical
                      class="h6"
                      style="color:black"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="orderMovementState === 'PrepareInTransit'"
                    v-b-modal.edit-article-in-movement-modal
                    @click="articleInMovement(article)"
                  >
                    <span style="display:flex;gap:5px">
                      <b-icon-pencil />
                      <p>
                        {{ $t('Edit') }}
                      </p>
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="orderMovementState === 'PrepareInTransit'"
                    v-b-modal.delete-article-in-movement-modal
                    @click="articleInMovement(article)"
                  >
                    <span
                      style="display:flex;gap:5px"
                    >
                      <b-icon-trash />
                      <p>
                        {{ $t('Delete') }}
                      </p>
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="orderMovementState === 'InTransit'"
                  >
                    <span style="display:flex;gap:5px">
                      <b-icon-pencil />
                      <p>
                        {{ $t('Edit') }}
                      </p>
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <p style="color:red;">
        {{ textAcceptance }}
      </p>
      <div style="margin-top:10px;justify-content: flex-end;display: flex;gap:10px;">
        <button
          class="primary-cancel"
          @click="onCancelToggle"
        >
          {{ $t('CloseWindow') }}
        </button>
        <button
          v-b-modal.confirm-save-internal-movement-modal
          class="primary"
        >
          <div
            v-if="loading"
            style="width:100%"
            class="pdf-spinner-overlay"
          >
            <span class="loader" />
          </div>
          {{ $t('Save') }}
        </button>
      </div>
    </div>
    <ConfirmSaveInternalMovement
      :clicked-order-movement-id="clickedOrderMovementId"
      :order-movement-state="orderMovementState"
      @updateMovementsDetail="updateMovementsDetails"
      @updateListOnClose="updateListOnClose"
    />
    <DeleteLineItemMovement
      :clicked-line-item-movement-id="clickedLineItemMovementId"
      :clicked-order-number="clickedOrderNumber"
      @updateMovementsDetail="updateMovementsDetails"
    />
    <DeleteArticleInMovement
      :clicked-product-movement-id="clickedProductMovementId"
      :clicked-article-number="clickedArticleNumber"
      @updateMovementsDetail="updateMovementsDetails"
    />
    <EditArticleMovement
      :amount-of-product="amountOfProduct"
      :clicked-article-number="clickedArticleNumber"
      :clicked-product-movement-id="clickedProductMovementId"
      @updateMovementsDetail="updateMovementsDetails"
    />
    <AddOrderMovementsToLocation
      :products-in-stock-list="productsInStockList"
      :order-item-ids="orderItemIds"
      @removeListsOrderArticle="removeListsOrderArticles"
      @updateOrderMovementsDetails="updateMovementsDetails"
    />
    <div
      v-if="isDownloadingPDF"
      style="width:100%"
      class="pdf-spinner-overlay"
    >
      <span class="loader" />
    </div>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import jsPDF from 'jspdf';
import {
  xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo,
} from '../../iconsImageUsers';
import 'jspdf-autotable';
import 'vue2-datepicker/index.css';
import DeleteLineItemMovement from './DeleteLineItemMovement.vue';
import DeleteArticleInMovement from './DeleteArticleInMovement.vue';
import EditArticleMovement from './EditArticleMovement.vue';
import AddOrderMovementsToLocation from './AddOrderMovementsToLocation.vue';
import ConfirmSaveInternalMovement from './ConfirmSaveInternalMovement.vue';


export default {
  components: {
    DatePicker,
    DeleteLineItemMovement,
    DeleteArticleInMovement,
    EditArticleMovement,
    AddOrderMovementsToLocation,
    ConfirmSaveInternalMovement,
  },
  props: ['clickedOrderMovementId', 'orderMovementState'],
  data() {
    return {
      loading: false,
      responsibleUser: '',
      receiverStoreName: null,
      deliverStoreName: null,
      deliveryDate: null,
      clickedOrderNumber: null,
      clickedLineItemMovementId: null,
      clickedProductMovementId: null,
      clickedArticleNumber: null,
      amountOfProduct: 0,
      isDownloadingPDF: false,
      toLocation: null,
      productsInStockList: [],
      orderItemIds: [],
      selectAllProducts: false,
      selectAllOrders: false,
      textAcceptance: '',
    };
  },
  computed: {
    ...mapGetters([
      'getOrderMovementDetails',
      'getOrderMovementDetailsPDF',
      'getAllStoresDropdown',
      'getLocationsByStoreIdName',
      'getRegularEmployeesById',
    ]),
    filteredStoresDeliverer() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned';
      });

      const updatedStores = filteredStores.map((store) => {
        return {
          ...store,
          deliverStoreName: store.storeName,
          deliverStoreId: store.storeId,
        }
      });

      const allOption = { storeId: null, deliverStoreName: 'No store', storeGLN: null };
      return [allOption, ...updatedStores];
    },
    filteredStoresReceiver() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned';
      });

      const updatedStores = filteredStores.map((store) => {
        return {
          ...store,
          receiverStoreName: store.storeName,
          receiverStoreId: store.storeId,
        }
      });

      return updatedStores
    },
    filteredResponsibleUsers() {
      return this.getRegularEmployeesById?.map((item) => {
        return {
          ...item,
          userFullName: item.name,
        }
      });
    },
  },
  watch: {
    getOrderMovementDetails: {
      handler(newVal) {
        if (newVal) {
          this.responsibleUser = newVal.userId;

          this.receiverStoreName = newVal.receiverStoreId
            ? newVal.receiverStoreId.toString().toUpperCase()
            : null;

          this.deliverStoreName = newVal.deliverStoreId
            ? newVal.deliverStoreId.toString().toUpperCase()
            : null;

          this.deliveryDate = moment(newVal.deliveryDate).format('YYYY-MM-DD');
        }
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'loadOrderMovementDetails',
      'loadUpdateReceiverStoreIdByOrderMovement',
      'loadUpdateUserIdByOrderMovement',
      'loadUpdateDeliveryDateByOrderMovement',
      'loadUpdateStateByOrderMovement',
      'loadRegularEmployeesId',
      'loadOrderMovementDetailsPDF',
      'loadLocationsByStoreIdName',
      'loadUpdateLocation',
    ]),
    removeListsOrderArticles() {
      this.productsInStockList = [];
      this.orderItemIds = [];
      this.selectAllProducts = false;
      this.selectAllOrders = false;
    },
    toggleOrderItem(event, index) {
      const item = this.getOrderMovementDetails?.lineItemMovementPendingResponseDtos[index];
      const itemObject = {
        windowItemId: item.windowItemId,
        orderItemId: item.orderItemId,
        articleNumber: item.articleNumber,
        orderNumber: item.orderNumber,
        lineItemMovementId: item.lineItemMovementId,
      };

      if (event.target.checked) {
        this.orderItemIds.push(itemObject);
      } else {
        const itemIndex = this.orderItemIds.findIndex(
          (i) => { return i.windowItemId === item.windowItemId && i.orderItemId === item.orderItemId && i.articleNumber === item.articleNumber && i.orderNumber === item.orderNumber && i.lineItemMovementId === item.lineItemMovementId },
        );
        if (itemIndex !== -1) {
          this.orderItemIds.splice(itemIndex, 1);
        }
      }
      this.selectAllOrders = this.orderItemIds.length === this.getOrderMovementDetails?.lineItemMovementPendingResponseDtos.length;
    },
    toggleSelectAllOrdersOrder(event) {
      this.selectAllOrders = event.target.checked;

      if (this.selectAllOrders) {
        this.orderItemIds = this.getOrderMovementDetails?.lineItemMovementPendingResponseDtos.map((item) => {
          return {
            windowItemId: item.windowItemId,
            orderItemId: item.orderItemId,
            articleNumber: item.articleNumber,
            orderNumber: item.orderNumber,
            lineItemMovementId: item.lineItemMovementId,
          }
        });
      } else {
        this.orderItemIds = [];
      }
    },
    isOrderItemChecked(item) {
      return this.orderItemIds.some(
        (i) => { return i.windowItemId === item.windowItemId },
      );
    },
    toggleProductItem(event, index) {
      const item = this.getOrderMovementDetails?.productInStockMovementPendingResponseDtos[index];
      const itemObject = {
        productInStockId: item.productInStockId,
        productInStockMovementId: item.productInStockMovementId,
        amount: item.amount,
        articleNumber: item.articleNumber,
        notes: item.notes || '',
      };

      if (event.target.checked) {
        this.productsInStockList.push(itemObject);
      } else {
        const itemIndex = this.productsInStockList.findIndex(
          (i) => { return i.productInStockId === item.productInStockId && i.amount === item.amount && i.articleNumber === item.articleNumber && i.productInStockMovementId === item.productInStockMovementId },
        );
        if (itemIndex !== -1) {
          this.productsInStockList.splice(itemIndex, 1);
        }
      }
      this.selectAllProducts = this.productsInStockList.length === this.getOrderMovementDetails?.productInStockMovementPendingResponseDtos.length;
    },
    toggleSelectAllProductsProducts(event) {
      this.selectAllProducts = event.target.checked;

      if (this.selectAllProducts) {
        this.productsInStockList = this.getOrderMovementDetails?.productInStockMovementPendingResponseDtos.map((item) => {
          return {
            productInStockId: item.productInStockId,
            productInStockMovementId: item.productInStockMovementId,
            amount: item.amount,
            articleNumber: item.articleNumber,
            notes: item.notes || '',
          }
        });
      } else {
        this.productsInStockList = [];
      }
    },
    isProductItemChecked(item) {
      return this.productsInStockList.some(
        (i) => { return i.productInStockId === item.productInStockId },
      );
    },
    updateLocationAcepted(value) {
      this.loadUpdateLocation({
        orderMovementId: this.clickedOrderMovementId,
        locationId: value,
      })
    },
    updateDeliveryDate(value) {
      this.loadUpdateDeliveryDateByOrderMovement({
        orderMovementId: this.clickedOrderMovementId,
        deliverDate: value,
      })
    },
    updateResponsibleUser(value) {
      this.loadUpdateUserIdByOrderMovement({
        orderMovementId: this.clickedOrderMovementId,
        userId: value,
      })
    },
    updateReceiver(value) {
      if (value) {
        this.responsibleUser = null
        this.toLocation = null
        this.loadUpdateReceiverStoreIdByOrderMovement({
          orderMovementId: this.clickedOrderMovementId,
          receiverStoreId: value,
        })
        this.loadLocationsByStoreIdName({
          storeId: value,
        })
        this.loadRegularEmployeesId({
          storeId: value,
        })
        this.loadUpdateUserIdByOrderMovement({
          orderMovementId: this.clickedOrderMovementId,
          userId: this.responsibleUser,
        })
      }
    },
    updateMovementsDetails() {
      this.loadOrderMovementDetails({
        orderMovementId: this.clickedOrderMovementId,
      })
      this.productsInStockList = [];
      this.orderItemIds = [];
      this.selectAllProducts = false;
      this.selectAllOrders = false;
      this.textAcceptance = ''
    },
    articleInMovement(value) {
      this.amountOfProduct = value.amount;
      this.clickedArticleNumber = value.articleNumber
      this.clickedProductMovementId = value.productInStockMovementId;
    },
    deleteLineItem(value) {
      this.clickedOrderNumber = value.orderNumber
      this.clickedLineItemMovementId = value.lineItemMovementId;
    },
    updateListOnClose() {
      this.$emit('updateMovementsListOnClose');
      this.onCancelToggle()
    },
    onCancelToggle() {
      this.$refs.modal.hide();
      this.textAcceptance = ''
      this.$emit('onCancelToggle');
    },
    async downloadPDF(value) {
      this.isDownloadingPDF = true;

      try {
        await this.loadOrderMovementDetailsPDF({
          orderMovementId: value,
        });

        const tableContent = this.generateLineItemsTablePDF(this.getOrderMovementDetailsPDF?.lineItemMovementPendingResponseDtos);
        const tableContent2 = this.generateProductsInStockTablePDF(this.getOrderMovementDetailsPDF?.productInStockMovementPendingResponseDtos);
        const pdfDocument = this.generatePDF(tableContent, tableContent2, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800);

        pdfDocument.save(`${this.$t('orderMovementNumber')}: ${this.getOrderMovementDetailsPDF?.orderMovementNumber}-${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
      } catch (error) {
        console.error('Error downloading the data:', error);
      } finally {
        this.isDownloadingPDF = false;
      }
    },
    generateProductsInStockTablePDF(items) {
      const headers1 = [
        `${this.$t('No.')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Barcode')}`,
        `${this.$t('Amount')}`,
        `${this.$t('State')}`,
      ];


      let body1 = [];

      if (!items || items.length === 0) {
        body1 = [[
          1,
          '—',
          '—',
          '—',
        ]];
      } else {
        body1 = items.map((item, index) => {
          return [
            index + 1,
            item.articleNumber,
            item.barcode || this.$t('NoBarcode'),
            item.amount || 0,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers1,
        body1,
      };
    },
    generateLineItemsTablePDF(items) {
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('OrderNumber')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('State')}`,
      ];

      let body = [];

      if (!items || items.length === 0) {
        body = [[
          1,
          '—',
          '—',
        ]];
      } else {
        body = items.map((item, index) => {
          return [
            index + 1,
            item.orderNumber,
            item.articleNumber,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers,
        body,
      };
    },
    generatePDF(tableContent, tableContent2, firstIcon, secondIcon, thirdIcon, fourthIcon, fifthIcon, sixthIcon, customWidth) {
      const { headers, body } = tableContent;
      const { headers1, body1 } = tableContent2;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const firstText = `${this.$t('State')} : ${this.$t(this.orderMovementState)}`;
      const firstTextX = 40;
      const firstTextY = 90;
      doc.setFontSize(15);
      doc.setFont('Helvetica', 'normal');
      doc.setTextColor(0, 0, 0);
      doc.text(firstText, firstTextX, firstTextY, { align: 'left' });

      const inlineGap = 35;

      const secondText = `${this.$t('deliverDate')} : ${moment(this.getOrderMovementDetailsPDF?.deliverDate).format('YYYY-MM-DD')}`;
      const secondTextX = firstTextX + doc.getTextWidth(firstText) + inlineGap;
      doc.text(secondText, secondTextX, firstTextY, { align: 'left' });

      const verticalGap = 25;

      const thirdText = `${this.$t('deliverStoreName')} : ${this.getOrderMovementDetails?.deliverStoreName}`;
      const thirdTextX = firstTextX;
      const thirdTextY = firstTextY + verticalGap;
      doc.text(thirdText, thirdTextX, thirdTextY, { align: 'left' });

      // Calculate width of thirdText
      const thirdTextWidth = doc.getTextWidth(thirdText);
      const receiverGap = 20;

      const fourthText = `${this.$t('receiverStoreName')} : ${this.getOrderMovementDetails?.receiverStoreName}`;
      // Place fourthText after thirdText + gap
      const fourthTextX = thirdTextX + thirdTextWidth + receiverGap;
      const fourthTextY = thirdTextY;
      doc.text(fourthText, fourthTextX, fourthTextY, { align: 'left' });

      const staticContent = () => {
        const title = `${this.$t('orderMovementNumber')} : ${this.getOrderMovementDetailsPDF?.orderMovementNumber}`;
        const titleY = 50;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 5;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(firstIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        // Location and Phone details
        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = doc.internal.pageSize.getHeight() - 90; // Start just above the footer
        const locationSpacing = 132; // Space between each location block

        const startXPosition = 40; // Starting position for the first location
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132; // End X position based on number of locations

        // Loop through the locations array and display each one
        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing; // Adjust X position for each location
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0); // Black color

          // Add the location icon
          const iconXPosition = xPosition - 25; // Position the icon just before the location name
          const iconYPosition = locationsY - 10; // Position the icon just above the location name
          doc.addImage(secondIcon, 'PNG', iconXPosition, iconYPosition, 28, 29); // Icon size 10x10 (adjust as needed)

          // Display the location name
          doc.text(location.name, xPosition, locationsY);

          doc.text(location.name2, xPosition, locationsY + 15);

          // Display the phone number below the location name
          doc.text(location.phone, xPosition, locationsY + 30); // Position phone number below the location name
        });

        // Add a line under the locations block, spanning the width of the locations
        doc.setDrawColor(0, 0, 0); // Black color for the line
        const lineY = locationsY + 40; // Position the line just below the last location's phone number
        doc.line(startXPosition, lineY, endXPosition, lineY); // Draw a line across the width of the locations

        // Show the three items in a row below the line
        const itemsXStart = 40; // Starting position for the row of items
        const itemsY = lineY + 3; // Y-position for the items row

        const items = [
          { icon: fourthIcon, text: 'NOTAbrillantOfficial' },
          { icon: fifthIcon, text: 'nota.brillant' },
          { icon: sixthIcon, text: 'info@notabrillantofficial.com' },
        ];

        // Space between each item in the row
        const itemSpacing = 150; // Adjust this for the space between icons and text

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing; // Calculate horizontal position for each item

          // Add the icon and text next to each other
          doc.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20); // Icon position and size
          doc.setFontSize(12);
          doc.text(item.text, xPosition + 25, itemsY + 15); // Position text next to the icon (adjust the X offset if needed)
        });

        // QR code section
        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = doc.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2; // Center the text above the QR code
        const qrCodeTextY = doc.internal.pageSize.getHeight() - 60; // Adjust the Y position to place text above the QR code
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(qrCodeText, qrCodeTextX, qrCodeTextY);

        // Add the QR code image
        doc.addImage(thirdIcon, 'PNG', 680, doc.internal.pageSize.getHeight() - 50, 45, 45);

        // Footer section
        const footerText = 'Powered by DigIT';
        const footerTextWidth = doc.getTextWidth(footerText);
        const centerX = (doc.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;

        doc.setFontSize(10);
        doc.setTextColor(160, 160, 160);
        doc.text(footerText, centerX, footerY);
      };

      const tableLeftMargin = 40;

      // Add header "Orders" before the first table
      doc.setFontSize(16); // Adjust the font size for the header
      doc.text(this.$t('Orders'), tableLeftMargin, 150);
      doc.autoTable({
        startY: 160,
        head: [headers],
        body,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      const firstTableEndY = doc.lastAutoTable.finalY;

      // Add header "Products" before the second table
      doc.setFontSize(16); // Adjust font size for the second header
      doc.text(this.$t('Products'), tableLeftMargin, firstTableEndY + 20);

      const secondTableStartY = firstTableEndY + 30; // Where the second table will start

      // Check available space for the second table
      const availableSpace = doc.internal.pageSize.getHeight() - secondTableStartY - 20; // 20 for margin

      // If the available space is less than the second table's height, add a page break
      if (availableSpace < 150) { // Assuming the second table is around 150pt high
        doc.addPage();
        doc.setFontSize(16); // Header for the second table again
        doc.text(this.$t('Products'), tableLeftMargin, 40); // Start the second table header at the top of the page
      }

      // Start the second table at Y position 250 if it's on the second page
      const secondTableStartYPosition = doc.internal.getNumberOfPages() > 1 ? 250 : secondTableStartY;

      doc.autoTable({
        startY: secondTableStartYPosition,
        head: [headers1],
        body: body1,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          4: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      return doc;
    },
  },
};
</script>

  <style scoped>
  .pdf-spinner-overlay {
    width: 100%;
}
      .display-elements {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 5px;
      }
      .table-elements {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;

      }
  </style>
